(function () {
    'use strict';

    angular
        .module('franchiser.components')
        .controller('UnitFranchiseeHistoryListFranchiserController', UnitFranchiseeHistoryListFranchiserController)

    /** @ngInject */
    function UnitFranchiseeHistoryListFranchiserController($q, $httpParamSerializer, UnitService, FranchiseeHistoryService, HelperService, ROUTES, ReportDownloadService) {
        const vm = this;

        let isTableSearch = false;
        let forcePaginationReset = false;
        let allUnits = [];

        vm.isSearchDisabled = () => {
            if (vm.selectedUnit || (vm.selectedSearchField && vm.searchText))
                return false;

            return true;
        }

        vm.isClearDisabled = () => {
            if (isTableSearch)
                return false;

            if (vm.selectedUnit || vm.selectedSearchField || vm.searchText)
                return false;

            return true;
        }

        vm.doSearch = (event, isFromButton) => {
            if (!vm.isSearchDisabled() && (event && event.keyCode == 13) || isFromButton) {
                forcePaginationReset = true;
                vm.isFirstCall = false;
                vm.isLoading = true;

                vm.tableCallServer();
            }
        }

        vm.clearSearch = () => {
            vm.selectedUnit = null;
            vm.selectedSearchField = null;
            vm.searchText = null;
            vm.franchisees = [];
            vm.isFirstCall = true;

            isTableSearch = false;
        }

        vm.tableCallServer = (tableState, stCtrl) => {
            if (!vm.stCtrl && stCtrl)
                vm.stCtrl = stCtrl;

            if (!tableState && vm.stCtrl) {
                vm.stCtrl.pipe();
                return;
            }

            if (vm.isFirstCall) {
                vm.isLoading = false;
                return;
            }

            if (forcePaginationReset) {
                tableState.pagination.start = 0;
                forcePaginationReset = false;
            }

            const pagination = tableState.pagination;
            const start = pagination.start || 0;
            const number = pagination.number || 10;

            getFranchisees(start, number, tableState);
        }

        vm.getUnits = search => {
            if (!search) {
                vm.units = [];
                return;
            }

            vm.units = allUnits.filter(unit => filterUnit(unit, search))
        }

        vm.configureReportDownload = () => {
            const parameters = prepareReportParameters();

            return ReportDownloadService.download('franchisees-history-report', parameters);
        }

        init();

        function getFranchisees(skip, perPage, tableState) {
            let parameters = prepareParameters(skip, perPage, tableState);

            FranchiseeHistoryService
                .getByParameters(parameters)
                .then(success => {
                    vm.franchisees = success.Franchisees;
                    tableState.pagination.numberOfPages = success.NumberOfPages;

                    vm.isLoading = false;
                }, error => {
                    vm.people = null;
                    vm.isLoading = false;
                    HelperService.errorCallback(error);
                })
        }

        function getAllUnitsResumed() {
            return UnitService
                .getAllResumed()
                .then(success => {
                    allUnits = success;
                }, error => {
                    HelperService.errorCallback(error);
                    HelperService.stopLoading('.custom-filters');
                })
        }

        function filterUnit(unit, search) {
            if (unit.FantasyName == null)
                unit.FantasyName = '';

            if (unit.CorporateName == null)
                unit.CorporateName = '';

            if (unit.UniqueCode == null)
                unit.UniqueCode = '';

            if (unit.ExternalCode == null)
                unit.ExternalCode = '';

            if (unit.FantasyName.toLowerCase().includes(search.toLowerCase()) || unit.CorporateName.toLowerCase().includes(search.toLowerCase()) || unit.UniqueCode.toString().includes(search) || unit.ExternalCode.toString().includes(search))
                return unit;
        }

        function prepareParameters(skip, perPage, tableState) {
            let params = {
                Skip: skip,
                PerPage: perPage,
                OrderBy: 'Name',
                OrderDescending: false
            }

            if (vm.selectedUnit || (vm.selectedSearchField && vm.searchText))
                isTableSearch = true;

            if (vm.selectedUnit)
                params.UnitId = vm.selectedUnit.Id;

            if (tableState.sort.predicate) {
                params.OrderBy = tableState.sort.predicate;
                params.OrderDescending = tableState.sort.reverse;
            }

            if (vm.selectedSearchField && vm.searchText) {
                params.SearchField = vm.selectedSearchField.Value;
                params.SearchQuery = vm.searchText;
            }

            return params;
        }

        function prepareReportParameters() {
            let params = {};

            if (vm.selectedUnit)
                params.UnitId = vm.selectedUnit.Id;

            if (vm.selectedSearchField && vm.searchText) {
                params.SearchField = vm.selectedSearchField.Value;
                params.SearchQuery = vm.searchText;
            }

            return params;
        }

        function init() {
            vm.selectedUnit;
            vm.selectedSearchField;
            vm.searchText;
            vm.isLoading = false;
            vm.isFirstCall = true;

            vm.searchFields = [{
                Id: 1,
                Value: 'Cpf',
                Description: 'CPF'
            }, {
                Id: 2,
                Value: 'Name',
                Description: 'Nome'
            }, {
                Id: 3,
                Value: 'Email',
                Description: 'E-mail'
            }];

            HelperService.startLoading('.custom-filters');

            $q.all([getAllUnitsResumed()])
                .then(() => {
                    HelperService.stopLoading('.custom-filters');
                })
        }
    }
}());